import React, { useState } from 'react';
import { connect, useIntl } from 'umi';
import { Layout } from "tea-component";

import SpendKeyPerformanceMetrics from './components/SpendKeyPerformanceMetrics';
import SpendTrendChart from './components/SpendTrendChart';
import SpendRankTop from './components/SpendRankTop';
import SpendOverallPerformance from './components/SpendOverallPerformance';
import SpendFilter from '@/pages/dashboard/filterPageComponents/ua/spendFilterNew';
import NoPermission from "@/pages/dashboard/components/NoPermissionNew";
import { useBuriedPoint } from "@/pages/home/utils/customHook";
import MarqueeInfo from "@/pages/dashboard/components/MarqueeInfo";
import { FORM_MAP } from './_config/constant';

import '@/pages/dashboard/assets/scss/page/Ua/ua.scss';
import { SubTitle } from '../../components/SubTitle';

const { Content } = Layout;

function Spend(props: any) {
  const {
    explainInfo,
    gameCode
  } = props;

  const [formValue, setFormValue] = useState<any>({
    filterValue: null,
    newFilter: true,
    timeType: 'Day',
    [FORM_MAP.RANGE_TIME_DIFF]: false,
  });
  const [filterLoading, setFilterLoading] = useState(true);
  const [noAuth, setNoAuth] = useState(false);
  const { formatMessage } = useIntl();

  // 打点信息
  const logObj = {
    pageId: '201101',
    pageName: 'uaSpend',
    extInfo: 'uaSpend',
    pagePath: '/ua/spend',
    uid: gameCode,
    typeId: 'dashboard_pc_v2',
  };
  useBuriedPoint(logObj);


  const handleConfirm = async (value: any) => {
    setFormValue({
      ...value,
    }); // 设置筛选器参数
  };
  const handleInit = (value: any) => {
    setFormValue({
      ...formValue,
      ...value,
    });
    setFilterLoading(false);
  };

  return (<>
    {noAuth && <NoPermission gameCode={gameCode} showButton={false} message={formatMessage({ id: 'ua_no_auth_message' })} />}
    <Content className='ua dbd-ua-box dbd-scroll-body' style={{ display: noAuth ? 'none' : 'block' }}>
      <Content.Header title="UA" subtitle={<SubTitle/>} />
      <Content.Body full>
        <MarqueeInfo pagePath={"/ua/spend"} />
        <SpendFilter
          openSticky={true}
          gameCode={gameCode}
          buttonLogConfig={{ pageId: '201101', confirmButtonId: '201101001', resetButtonId: '201101002' }}
          filterConfirm={handleConfirm}
          filterReset={handleConfirm}
          filterInit={handleInit}
          setFilterLoading={setFilterLoading}
        />
        <SpendKeyPerformanceMetrics
          explainInfo={explainInfo}
          gameCode={gameCode}
          filterLoading={filterLoading}
          formValue={formValue}
          setNoAuth={setNoAuth}
        />
        <SpendTrendChart
          gameCode={gameCode}
          filterLoading={filterLoading}
          formValue={formValue}
        />
        <SpendOverallPerformance
          explainInfo={explainInfo}
          gameCode={gameCode}
          filterLoading={filterLoading}
          formValue={formValue}
        />
        <SpendRankTop
          gameCode={gameCode}
          filterLoading={filterLoading}
          formValue={formValue}
        />
      </Content.Body>
    </Content>
  </>);
}

export default connect((state: any) => ({
  explainInfo: state.dashboard?.explainInfo,
  gameCode: state.dashboard?.currentGame?.game_code,
}))(Spend);
